export enum FixingFillType {
  FIXING_RATES,
  REVAL_RATES,
}

export namespace FixingFillType {
  let elements = [FixingFillType.FIXING_RATES, FixingFillType.REVAL_RATES];
  let alias = "com.bcdfx.model.FixingFillType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
